function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExcel = function SvgExcel(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#4CAF50"
    },
    d: "M294.656,13.014c-2.531-2.056-5.863-2.842-9.045-2.133l-277.333,64 C3.397,76.003-0.047,80.369,0,85.377v362.667c0.002,5.263,3.843,9.739,9.045,10.539l277.333,42.667 c5.823,0.895,11.269-3.099,12.164-8.921c0.082-0.535,0.124-1.076,0.124-1.617V21.377C298.676,18.124,297.199,15.045,294.656,13.014 z"
  }), React.createElement("path", {
    style: {
      fill: "#4CAF50"
    },
    d: "M501.334,458.71H288c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667 h202.667V74.71H288c-5.891,0-10.667-4.776-10.667-10.667S282.109,53.377,288,53.377h213.333c5.891,0,10.667,4.776,10.667,10.667 v384C512,453.935,507.225,458.71,501.334,458.71z"
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M202.667,352.044c-3.678,0-7.096-1.895-9.045-5.013L86.955,176.364 c-3.279-4.894-1.969-11.52,2.925-14.799s11.52-1.969,14.799,2.925c0.129,0.192,0.251,0.388,0.367,0.588l106.667,170.667 c3.11,5.003,1.576,11.58-3.427,14.691C206.599,351.484,204.653,352.041,202.667,352.044z"
  }), React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M96,352.044c-5.891-0.012-10.657-4.797-10.645-10.688c0.004-1.992,0.566-3.943,1.621-5.632 l106.667-170.667c2.954-5.097,9.481-6.834,14.577-3.88c5.097,2.954,6.834,9.481,3.88,14.577c-0.116,0.2-0.238,0.396-0.367,0.588 L105.067,347.009C103.119,350.142,99.69,352.047,96,352.044z"
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#4CAF50"
    },
    d: "M373.334,458.71c-5.891,0-10.667-4.776-10.667-10.667v-384c0-5.891,4.776-10.667,10.667-10.667 c5.891,0,10.667,4.776,10.667,10.667v384C384,453.935,379.225,458.71,373.334,458.71z"
  }), React.createElement("path", {
    style: {
      fill: "#4CAF50"
    },
    d: "M501.334,394.71H288c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667 h213.333c5.891,0,10.667,4.776,10.667,10.667C512,389.935,507.225,394.71,501.334,394.71z"
  }), React.createElement("path", {
    style: {
      fill: "#4CAF50"
    },
    d: "M501.334,330.71H288c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667 h213.333c5.891,0,10.667,4.776,10.667,10.667C512,325.935,507.225,330.71,501.334,330.71z"
  }), React.createElement("path", {
    style: {
      fill: "#4CAF50"
    },
    d: "M501.334,266.71H288c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667 h213.333c5.891,0,10.667,4.776,10.667,10.667C512,261.935,507.225,266.71,501.334,266.71z"
  }), React.createElement("path", {
    style: {
      fill: "#4CAF50"
    },
    d: "M501.334,202.71H288c-5.891,0-10.667-4.776-10.667-10.667s4.776-10.667,10.667-10.667h213.333 c5.891,0,10.667,4.776,10.667,10.667S507.225,202.71,501.334,202.71z"
  }), React.createElement("path", {
    style: {
      fill: "#4CAF50"
    },
    d: "M501.334,138.71H288c-5.891,0-10.667-4.776-10.667-10.667c0-5.891,4.776-10.667,10.667-10.667 h213.333c5.891,0,10.667,4.776,10.667,10.667C512,133.935,507.225,138.71,501.334,138.71z"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgExcel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/excel.65f3cac7.svg";
export { ForwardRef as ReactComponent };